// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13keB","label":"styles_label__2_xkt"};